import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

export default function ImageTransition() {
  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start end", "end start"]
  });

  // Cinematic slow zoom as the image passes through the viewport
  const scale = useTransform(scrollYProgress, [0, 1], [1.2, 1]);
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

  // Responsive height: shorter on mobile to prevent side-cropping of the landscape image
  return (
    <section ref={containerRef} className="relative h-[40vh] sm:h-[50vh] md:h-[80vh] lg:h-screen w-full overflow-hidden bg-brand-light">
      <motion.div 
        style={{ scale, y }}
        className="absolute inset-0 w-full h-full"
      >
        <img 
          src="https://media-manager-c.questera.ai/greta-media/84bd1a1ec4b169d3b45fb6d9222544ea571861834b2a41df59b8dd4fbd9877604e1a1a824c0c77323e9e6a3b81021929/images/aW1hZ2UvanBlZw==/c71684d42bc268a562331e4b9c9e7db0.jpg" 
          alt="Yes We Care" 
          className="w-full h-full object-cover object-center"
        />
      </motion.div>
    </section>
  );
}